import "./index.scss";
import { Loader } from "components/UI/atoms";

export const FallbackLoader = () => {
  return (
    <div className="suspense-loader">
      <Loader />
    </div>
  );
};
